import axios from 'axios';

const API_BASE_URL = 'https://psgc.gitlab.io/api';

// Fetch regions first
export const fetchRegions = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/regions`);
    return response.data.map(region => ({
      code: region.code,
      name: region.name,
      regionName: region.regionName
    }));
  } catch (error) {
    console.error('Error fetching regions:', error);
    return [];
  }
};

// Fetch provinces by region
export const fetchProvincesByRegion = async (regionCode) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/regions/${regionCode}/provinces`);
    return response.data.map(province => ({
      code: province.code,
      name: province.name,
      regionCode: regionCode
    }));
  } catch (error) {
    console.error('Error fetching provinces by region:', error);
    return [];
  }
};

// Fetch all provinces
export const fetchProvinces = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/provinces`);
    return response.data.map(province => ({
      code: province.code,
      name: province.name
    }));
  } catch (error) {
    console.error('Error fetching provinces:', error);
    return [];
  }
};

// Updated to handle either province code, region code, or region+province combination
export const fetchCities = async (locationCode) => {
  try {
    let response;
    
    // Check if the code is a combined code (region|province)
    if (locationCode.includes('|')) {
      // Split the combined code (region|province)
      const [regionCode, provinceCode] = locationCode.split('|');
      
      if (provinceCode) {
        // If we have a province code, get cities by province
        response = await axios.get(`${API_BASE_URL}/provinces/${provinceCode}/cities-municipalities`);
      } else {
        // If we only have a region code, get cities directly by region
        response = await axios.get(`${API_BASE_URL}/regions/${regionCode}/cities-municipalities`);
      }
    } else {
      try {
        // First attempt to fetch cities by province code
        response = await axios.get(`${API_BASE_URL}/provinces/${locationCode}/cities-municipalities`);
      } catch (error) {
        if (error.response && error.response.status === 404) {
          // If province code fails, try fetching as a region code
          response = await axios.get(`${API_BASE_URL}/regions/${locationCode}/cities-municipalities`);
        } else {
          // If it's not a 404, rethrow the original error
          throw error;
        }
      }
    }
    
    return response.data.map(city => ({
      code: city.code,
      name: city.name
    }));
  } catch (error) {
    console.error('Error fetching cities:', error);
    return [];
  }
};

// Fetch barangays by city/municipality code
export const fetchBarangays = async (cityCode) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/cities-municipalities/${cityCode}/barangays`);
    return response.data.map(barangay => ({
      code: barangay.code,
      name: barangay.name
    }));
  } catch (error) {
    console.error('Error fetching barangays:', error);
    return [];
  }
};